<template>
  <div class="callback-container">
    <div class="callback-card">
      <i class="el-icon-loading" v-if="loading" style="font-size: 48px; color: #409EFF;"></i>
      <i class="el-icon-success" v-else-if="success" style="font-size: 48px; color: #67C23A;"></i>
      <i class="el-icon-error" v-else style="font-size: 48px; color: #F56C6C;"></i>
      <p style="margin-top: 20px; font-size: 16px;">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { dingtalkCallback } from '@/api/blog'

export default {
  name: 'DingTalkCallback',
  data() {
    return {
      loading: true,
      success: false,
      message: '正在处理钉钉登录...'
    }
  },
  async mounted() {
    const code = this.$route.query.code
    if (!code) {
      this.loading = false
      this.message = '缺少授权码，请重新登录'
      setTimeout(() => this.$router.replace('/admin/login'), 2000)
      return
    }
    
    const processedKey = 'dingtalk_code_' + code
    if (localStorage.getItem(processedKey)) {
      if (sessionStorage.getItem('admin_logged') === 'true') {
        this.loading = false
        this.message = '登录成功，正在跳转...'
        setTimeout(() => this.$router.replace('/admin'), 1000)
      } else {
        this.loading = false
        this.message = '授权码已被使用，请重新登录'
        setTimeout(() => this.$router.replace('/admin/login'), 3000)
      }
      return
    }
    
    localStorage.setItem(processedKey, 'true')
    setTimeout(() => localStorage.removeItem(processedKey), 5 * 60 * 1000)
    
    try {
      const res = await dingtalkCallback(code)
      const data = res.data
      if (data.success) {
        this.success = true
        this.message = `欢迎，${data.nick}！正在跳转...`
        sessionStorage.setItem('admin_logged', 'true')
        sessionStorage.setItem('admin_token', data.token)
        sessionStorage.setItem('admin_user', JSON.stringify({
          nick: data.nick,
          avatarUrl: data.avatarUrl,
          openId: data.openId
        }))
        setTimeout(() => this.$router.replace('/admin'), 1000)
      } else {
        this.loading = false
        this.message = '钉钉登录失败：' + (data.message || '未知错误')
        setTimeout(() => this.$router.replace('/admin/login'), 3000)
      }
    } catch (e) {
      this.loading = false
      this.message = '钉钉登录请求失败'
      setTimeout(() => this.$router.replace('/admin/login'), 3000)
    }
  }
}
</script>

<style scoped>
.callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.callback-card {
  background: white;
  padding: 60px;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  min-width: 300px;
}
</style>
